import AuroraA1 from './Aurora A.webp'
import AuroraA2 from './Aurora A.webp'


const AuroraAimages =[
AuroraA1,AuroraA2
]

export default AuroraAimages;